import { render, staticRenderFns } from "./GroupCallParticipant.vue?vue&type=template&id=32641de0&scoped=true"
import script from "./GroupCallParticipant.vue?vue&type=script&lang=js"
export * from "./GroupCallParticipant.vue?vue&type=script&lang=js"
import style0 from "./GroupCallParticipant.vue?vue&type=style&index=0&id=32641de0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32641de0",
  null
  
)

export default component.exports